import { useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Select } from 'antd'
import ArrowLeft from '../../../assets/icons/arrowLeft'
import ToggleSwitch from '../../../components/Switch/Switch'
import { Loading } from '../../../components/Loading/Loading'
import { Desativar } from '../../../components/Desativar'
import {
  FASE_OPTIONS,
  formatData,
  formatDataHora,
} from '../../GestaoTenants/gestaoTenants.helpers'
import { useOrganizacaoDetalhe } from './useOrganizacaoDetalhe'
import {
  Badge,
  BlocoDica,
  Botao,
  Botoes,
  BotaoVoltar,
  Campo,
  DescricaoSecao,
  Dica,
  Entrada,
  EntradaArquivo,
  ErroLogo,
  LinhaCampos,
  LinhaLogo,
  LinhaSwitch,
  ListaHistorico,
  LogoPreview,
  LogoVazio,
  Rotulo,
  Secao,
  TituloPagina,
  TituloSecao,
  Topo,
} from './style'

// Origem da relação Cliente x Vendedor (backend: OrigemClienteVendedorEnum). WS_W3ERP só é
// aceito com a integração ERP ativa — é dela que saem a URL e o token do WS.
const ORIGEM_CLIENTE_VENDEDOR_OPTIONS: {
  value: OrigemClienteVendedor
  label: string
}[] = [
  { value: 'VENDA', label: 'Pelas vendas (padrão)' },
  { value: 'WS_W3ERP', label: 'Pelo W3ERP (sincronizada diariamente)' },
]

// Teto do <input type="date"> do marco zero, em ISO. Montado por getFullYear/getMonth/getDate,
// e não por toISOString(): este último é UTC e, em UTC-3 depois das 21h, liberaria o dia
// seguinte no calendário local. A regra também é validada no backend — aqui é só evitar o
// round-trip.
const hojeISO = () => {
  const agora = new Date()
  const mes = `${agora.getMonth() + 1}`.padStart(2, '0')
  const dia = `${agora.getDate()}`.padStart(2, '0')
  return `${agora.getFullYear()}-${mes}-${dia}`
}

export function OrganizacaoDetalhe() {
  const {
    isNovo,
    carregando,
    organizacao,
    voltar,

    nome,
    setNome,
    tenantId,
    handleChangeTenant,
    moduloPredictAtivo,
    setModuloPredictAtivo,
    moduloMixAtivo,
    setModuloMixAtivo,
    chatSuporteAtivo,
    setChatSuporteAtivo,
    fase,
    setFase,
    erroNome,
    erroTenantObrigatorio,
    erroTenantInvalido,
    salvarDados,
    salvandoDados,

    logoInfo,
    logoUrl,
    carregandoLogo,
    logoIndisponivel,
    enviandoLogo,
    removendoLogo,
    erroLogo,
    enviarLogo,
    removerLogo,
    recarregarLogo,

    chave,
    setChave,
    token,
    setToken,
    url,
    setUrl,
    chaveCliente,
    setChaveCliente,
    chaveProduto,
    setChaveProduto,
    chaveClienteVendedor,
    setChaveClienteVendedor,
    origemClienteVendedor,
    handleChangeOrigemClienteVendedor,
    origemSalva,
    integracaoAtiva,
    handleChangeIntegracaoAtiva,
    erroChave,
    erroToken,
    erroUrl,
    erroOrigemClienteVendedor,
    executandoIntegracao,
    salvarConfigIntegracao,
    executarSync,
    executarEnriquecimento,
    executarClienteVendedor,

    idInstancia,
    setIdInstancia,
    tokenInstancia,
    setTokenInstancia,
    whatsAppAtivo,
    setWhatsAppAtivo,
    erroIdInstancia,
    erroTokenInstancia,
    criandoInstancia,
    salvandoWhatsApp,
    criarInstancia,
    salvarWhatsApp,

    jobRodando,
    executarSnapshot,
    executarReconciliacao,
    executarMixRecomendacao,
    executarCentralResultados,
    executarExpurgo,

    marcoZero,
    carregandoMarcoZero,
    marcoZeroIndisponivel,
    recarregarMarcoZero,
    novaDataMarco,
    setNovaDataMarco,
    novaObservacaoMarco,
    setNovaObservacaoMarco,
    salvandoMarcoZero,
    declararMarco,
  } = useOrganizacaoDetalhe()

  const [confirmaExpurgo, setConfirmaExpurgo] = useState(false)
  const [confirmaRemocaoLogo, setConfirmaRemocaoLogo] = useState(false)

  // Quatro estados na mesma moldura (carregando, com logo, falha de leitura, sem logo);
  // em função para não empilhar ternários no JSX.
  const previewLogo = () => {
    if (carregandoLogo) {
      return <LogoVazio>Carregando...</LogoVazio>
    }
    if (logoUrl) {
      return <img src={logoUrl} alt="Logo da empresa" />
    }
    if (logoIndisponivel) {
      return <LogoVazio>Não foi possível carregar a logo.</LogoVazio>
    }
    return <LogoVazio>Nenhuma logo cadastrada</LogoVazio>
  }

  // Quatro estados da leitura do marco zero (carregando, falha, declarado, nunca declarado);
  // em função para não empilhar ternários no JSX, como em previewLogo().
  // "Não deu para ler" tem texto próprio: afirmar "nenhum marco declarado" depois de um GET que
  // falhou levaria o super-admin a declarar um marco novo achando que é o primeiro.
  const marcoZeroEmLeitura = () => {
    if (carregandoMarcoZero) {
      return <BlocoDica>Carregando...</BlocoDica>
    }
    if (marcoZeroIndisponivel) {
      return (
        <BlocoDica>
          Não foi possível carregar o marco zero desta organização.
        </BlocoDica>
      )
    }
    if (!marcoZero) {
      return (
        <BlocoDica>
          Nenhum marco zero declarado para esta organização.
        </BlocoDica>
      )
    }
    return (
      <>
        <BlocoDica>
          <strong>{formatData(marcoZero.vigente.dataMarco)}</strong> — informado
          por {marcoZero.vigente.declaradoPorEmail} em{' '}
          {formatDataHora(marcoZero.vigente.dataDeclaracao)}.
        </BlocoDica>
        {marcoZero.vigente.observacao && (
          <BlocoDica>Observação: {marcoZero.vigente.observacao}</BlocoDica>
        )}
        {marcoZero.historico.length > 0 && (
          <>
            <BlocoDica>
              Declarações anteriores (mantidas como histórico):
            </BlocoDica>
            <ListaHistorico>
              {marcoZero.historico.map(item => (
                <li key={item.dataDeclaracao}>
                  {formatData(item.dataMarco)} — {item.declaradoPorEmail} em{' '}
                  {formatDataHora(item.dataDeclaracao)}
                  {item.observacao ? ` (${item.observacao})` : ''}
                </li>
              ))}
            </ListaHistorico>
          </>
        )}
      </>
    )
  }

  // Em modo edição, segura o render até a org resolver — evita o flash de 1 frame
  // (título/seções vazios) na transição criação -> edição, que reaproveita a instância.
  if (carregando || (!isNovo && !organizacao)) {
    return <Loading contrast={false} />
  }

  return (
    <>
      <Topo>
        <BotaoVoltar type="button" onClick={voltar} aria-label="Voltar">
          <ArrowLeft />
        </BotaoVoltar>
        <TituloPagina>
          {isNovo ? 'Nova organização' : organizacao?.nome}
        </TituloPagina>
        {!isNovo && organizacao && (
          <Badge ativo={organizacao.ativo}>
            {organizacao.ativo ? 'Ativa' : 'Inativa'}
          </Badge>
        )}
      </Topo>

      <Secao>
        <TituloSecao>Dados da organização</TituloSecao>
        <DescricaoSecao>
          Nome de exibição e sub-domínio (identificador do tenant).
        </DescricaoSecao>
        <LinhaCampos>
          <Campo>
            <Rotulo htmlFor="nome">Nome</Rotulo>
            <Entrada
              id="nome"
              type="text"
              value={nome}
              onChange={event => setNome(event.target.value)}
            />
            {erroNome && <span>*Campo obrigatório</span>}
          </Campo>
          <Campo>
            <Rotulo htmlFor="tenant">Sub-domínio</Rotulo>
            <Entrada
              id="tenant"
              largura="220px"
              type="text"
              value={tenantId}
              maxLength={52}
              disabled={!isNovo}
              onChange={event => handleChangeTenant(event.target.value)}
            />
            {isNovo && (
              <Dica>
                3 a 52 caracteres: letra inicial, minúsculas, números e _.
                Imutável depois.
              </Dica>
            )}
            {erroTenantObrigatorio && <span>*Campo obrigatório</span>}
            {erroTenantInvalido && (
              <span>
                *Use de 3 a 52 caracteres: comece com letra; só letras
                minúsculas, números e _
              </span>
            )}
          </Campo>
        </LinhaCampos>
        <DescricaoSecao style={{ marginTop: 20 }}>
          Módulos e recursos habilitados para este tenant (apenas visibilidade
          nas telas; o processamento em segundo plano não é afetado).
        </DescricaoSecao>
        <LinhaSwitch>
          <ToggleSwitch
            adm
            id="moduloPredictAtivo"
            label={`Predict Analytics ${
              moduloPredictAtivo ? 'ativo' : 'inativo'
            }`}
            checked={moduloPredictAtivo}
            onChange={() => setModuloPredictAtivo(!moduloPredictAtivo)}
          />
        </LinhaSwitch>
        <LinhaSwitch>
          <ToggleSwitch
            adm
            id="moduloMixAtivo"
            label={`Mix Inteligente ${moduloMixAtivo ? 'ativo' : 'inativo'}`}
            checked={moduloMixAtivo}
            onChange={() => setModuloMixAtivo(!moduloMixAtivo)}
          />
        </LinhaSwitch>
        {/* Chat de suporte: vem LIGADO por padrão (o toggle serve para desligar um tenant que
            tenha canal próprio de suporte). Só aparece na visualização do Cartivia. */}
        <LinhaSwitch>
          <ToggleSwitch
            adm
            id="chatSuporteAtivo"
            label={`Chat de suporte ${
              chatSuporteAtivo ?? true ? 'ativo' : 'inativo'
            }`}
            checked={chatSuporteAtivo ?? true}
            onChange={() => setChatSuporteAtivo(!(chatSuporteAtivo ?? true))}
          />
        </LinhaSwitch>
        {/* PD-0003: fase (ciclo de vida) do tenant. Modula o filtro/ranking do dashboard de gestão. */}
        <Campo style={{ marginTop: 20, maxWidth: 320 }}>
          <Rotulo>Fase do tenant</Rotulo>
          <Select
            style={{ width: '100%' }}
            value={fase}
            onChange={value => setFase(value as FaseTenant)}
            options={FASE_OPTIONS}
          />
        </Campo>
        <Botoes>
          <Botao type="button" disabled={salvandoDados} onClick={salvarDados}>
            {salvandoDados ? 'Salvando...' : 'Salvar'}
          </Botao>
        </Botoes>
      </Secao>

      {!isNovo && (
        <>
          {/* Logo da empresa: entra no cabeçalho do PDF de predição no lugar da marca
              Cartivia. Só em edição — o upload precisa do id da organização. */}
          <Secao>
            <TituloSecao>Logo da empresa</TituloSecao>
            <DescricaoSecao>
              Usada no cabeçalho do PDF de predição. Sem logo cadastrada, o
              relatório sai com a marca Cartivia.
            </DescricaoSecao>
            <LinhaLogo>
              <LogoPreview>{previewLogo()}</LogoPreview>
              <Campo>
                <Rotulo htmlFor="logo">Arquivo</Rotulo>
                <EntradaArquivo
                  id="logo"
                  type="file"
                  accept="image/png,image/jpeg"
                  disabled={enviandoLogo || removendoLogo}
                  onChange={event => {
                    const input = event.target
                    const arquivo = input.files?.[0]
                    // Zera o input para que escolher o MESMO arquivo de novo (após
                    // corrigi-lo) dispare um novo onChange.
                    input.value = ''
                    if (arquivo) enviarLogo(arquivo)
                  }}
                />
                <Dica>
                  PNG ou JPG, até 1 MB. Prefira PNG com fundo transparente, a
                  partir de 360×120 px.
                </Dica>
                {enviandoLogo && (
                  <Dica aria-live="polite">Enviando a logo...</Dica>
                )}
                {logoInfo && (
                  <Dica>
                    Atual: {logoInfo.larguraPx}×{logoInfo.alturaPx} px,{' '}
                    {Math.round(logoInfo.tamanhoBytes / 1024)} KB.
                  </Dica>
                )}
              </Campo>
            </LinhaLogo>
            {erroLogo && <ErroLogo role="alert">{erroLogo}</ErroLogo>}
            {/* Na falha de leitura o botão de remover CONTINUA disponível: a logo pode existir,
                e é justamente aí que o admin precisa da ação corretiva (o DELETE é idempotente). */}
            {(logoUrl || logoIndisponivel) && (
              <Botoes>
                <Botao
                  type="button"
                  variante="secundario"
                  disabled={enviandoLogo || removendoLogo}
                  onClick={() => setConfirmaRemocaoLogo(true)}
                >
                  {removendoLogo ? 'Removendo...' : 'Remover logo'}
                </Botao>
                {logoIndisponivel && (
                  <Botao
                    type="button"
                    variante="secundario"
                    disabled={carregandoLogo}
                    onClick={recarregarLogo}
                  >
                    Tentar novamente
                  </Botao>
                )}
              </Botoes>
            )}
          </Secao>

          {/* Marco zero (PD-0007): data de implantação DECLARADA, base da comparação
              "antes x depois" da Central de Resultados. Append-only — declarar de novo não
              edita, registra outra linha e a anterior fica como trilha. Por isso a vigente é
              leitura e o campo começa (e volta a ficar) vazio: um campo prefilled sugeriria
              edição, que é justamente o que o desenho impede. */}
          <Secao>
            <TituloSecao>Marco zero</TituloSecao>
            <DescricaoSecao>
              Data de implantação informada manualmente. Serve de ponto de
              partida para comparar a evolução da carteira. É uma declaração,
              não um dado apurado pelo sistema.
            </DescricaoSecao>

            {/* `Dica` é <small> (inline): fora de um <Campo> flex ela não quebra linha nem
                respeita largura, e os blocos colariam num parágrafo corrido. Mesmo tratamento
                da Dica da Integração ERP mais abaixo. */}
            <div role="status" aria-live="polite">
              {marcoZeroEmLeitura()}
            </div>

            {marcoZeroIndisponivel && (
              <Botoes>
                <Botao
                  type="button"
                  variante="secundario"
                  disabled={carregandoMarcoZero}
                  onClick={recarregarMarcoZero}
                >
                  Tentar novamente
                </Botao>
              </Botoes>
            )}

            <LinhaCampos>
              <Campo>
                <Rotulo htmlFor="dataMarco">
                  {marcoZero ? 'Declarar novo marco' : 'Data de implantação'}
                </Rotulo>
                {/* input nativo de data, e não o DatePicker compartilhado: o valor nativo já é
                    ISO yyyy-MM-dd, exatamente o que a API espera e devolve, então não há
                    conversão de formato no caminho. O DatePicker do projeto é não-controlado
                    (só expõe defaultValue) e não conseguiria ser limpo após salvar. */}
                <Entrada
                  id="dataMarco"
                  largura="220px"
                  type="date"
                  value={novaDataMarco}
                  max={hojeISO()}
                  disabled={salvandoMarcoZero}
                  onChange={event => setNovaDataMarco(event.target.value)}
                />
                <Dica>Não pode ser uma data futura.</Dica>
              </Campo>
              <Campo>
                <Rotulo htmlFor="observacaoMarco">Observação (opcional)</Rotulo>
                <Entrada
                  id="observacaoMarco"
                  type="text"
                  value={novaObservacaoMarco}
                  maxLength={500}
                  disabled={salvandoMarcoZero}
                  onChange={event => setNovaObservacaoMarco(event.target.value)}
                />
                <Dica>
                  Por que esta data. Fica registrada junto com a declaração.
                </Dica>
              </Campo>
            </LinhaCampos>

            {marcoZero && (
              <BlocoDica>
                A declaração atual não é apagada: ela passa a constar no
                histórico.
              </BlocoDica>
            )}

            <Botoes>
              <Botao
                type="button"
                variante="primario"
                disabled={salvandoMarcoZero || !novaDataMarco}
                onClick={declararMarco}
              >
                {salvandoMarcoZero ? 'Salvando...' : 'Declarar marco zero'}
              </Botao>
            </Botoes>
          </Secao>

          <Secao>
            <TituloSecao>Integração ERP (W3)</TituloSecao>
            <DescricaoSecao>
              Credenciais de sincronização de vendas e enriquecimento de
              catálogo.
            </DescricaoSecao>
            <LinhaCampos>
              <Campo>
                <Rotulo htmlFor="chave">Chave</Rotulo>
                <Entrada
                  id="chave"
                  type="text"
                  value={chave}
                  onChange={event => setChave(event.target.value)}
                />
                {erroChave && <span>*Campo obrigatório</span>}
              </Campo>
              <Campo>
                <Rotulo htmlFor="token">Token</Rotulo>
                <Entrada
                  id="token"
                  largura="220px"
                  type="text"
                  value={token}
                  onChange={event => setToken(event.target.value)}
                />
                {erroToken && <span>*Campo obrigatório</span>}
              </Campo>
            </LinhaCampos>
            <LinhaCampos style={{ marginTop: '20px' }}>
              <Campo>
                <Rotulo htmlFor="url">URL</Rotulo>
                <Entrada
                  id="url"
                  type="text"
                  value={url}
                  onChange={event => setUrl(event.target.value)}
                />
                {erroUrl && <span>*Campo obrigatório</span>}
              </Campo>
            </LinhaCampos>
            <LinhaCampos style={{ marginTop: '20px' }}>
              <Campo>
                <Rotulo htmlFor="chaveCliente">Chave cliente</Rotulo>
                <Entrada
                  id="chaveCliente"
                  type="text"
                  value={chaveCliente}
                  onChange={event => setChaveCliente(event.target.value)}
                />
                <Dica>Enriquecimento. Em branco, usa a chave padrão.</Dica>
              </Campo>
              <Campo>
                <Rotulo htmlFor="chaveProduto">Chave produto</Rotulo>
                <Entrada
                  id="chaveProduto"
                  largura="220px"
                  type="text"
                  value={chaveProduto}
                  onChange={event => setChaveProduto(event.target.value)}
                />
                <Dica>Enriquecimento. Em branco, usa a chave padrão.</Dica>
              </Campo>
            </LinhaCampos>
            {/* Origem da relação Cliente x Vendedor: derivada das vendas (padrão) ou buscada
                diariamente no WS dedicado do W3ERP, que passa a mandar em quais clientes cada
                vendedor enxerga. */}
            <LinhaCampos style={{ marginTop: '20px' }}>
              <Campo style={{ maxWidth: 320 }}>
                <Rotulo htmlFor="origemClienteVendedor">
                  Relação Cliente x Vendedor
                </Rotulo>
                <Select
                  id="origemClienteVendedor"
                  style={{ width: '100%' }}
                  value={origemClienteVendedor}
                  onChange={value =>
                    handleChangeOrigemClienteVendedor(
                      value as OrigemClienteVendedor
                    )
                  }
                  options={ORIGEM_CLIENTE_VENDEDOR_OPTIONS}
                />
                <Dica>
                  {origemClienteVendedor === 'WS_W3ERP'
                    ? 'A lista do ERP manda: cliente que não aparece nela fica sem vendedor.'
                    : 'Cada venda define o vendedor do cliente.'}
                </Dica>
                {erroOrigemClienteVendedor && (
                  <span>
                    *Buscar no W3ERP exige a integração ativa. Para desativá-la,
                    volte a relação para &quot;Pelas vendas&quot;.
                  </span>
                )}
              </Campo>
              <Campo>
                <Rotulo htmlFor="chaveClienteVendedor">
                  Chave cliente x vendedor
                </Rotulo>
                <Entrada
                  id="chaveClienteVendedor"
                  largura="220px"
                  type="text"
                  disabled={origemClienteVendedor !== 'WS_W3ERP'}
                  value={chaveClienteVendedor}
                  onChange={event =>
                    setChaveClienteVendedor(event.target.value)
                  }
                />
                <Dica>
                  {origemClienteVendedor === 'WS_W3ERP'
                    ? 'Em branco, usa a chave padrão.'
                    : 'Usada apenas com a origem "Pelo W3ERP".'}
                </Dica>
              </Campo>
            </LinhaCampos>
            <LinhaSwitch>
              <ToggleSwitch
                adm
                id="integracaoAtiva"
                label={integracaoAtiva ? 'Ativo' : 'Inativo'}
                checked={integracaoAtiva}
                onChange={handleChangeIntegracaoAtiva}
              />
            </LinhaSwitch>
            <Botoes>
              <Botao
                type="button"
                disabled={executandoIntegracao}
                onClick={salvarConfigIntegracao}
              >
                Salvar
              </Botao>
              {integracaoAtiva && (
                <Botao
                  type="button"
                  variante="secundario"
                  disabled={executandoIntegracao}
                  onClick={executarSync}
                >
                  Executar sincronização
                </Botao>
              )}
              {integracaoAtiva && (
                <Botao
                  type="button"
                  variante="secundario"
                  disabled={executandoIntegracao}
                  onClick={executarEnriquecimento}
                >
                  Executar enriquecimento
                </Botao>
              )}
              {/* Aparece assim que a opção é escolhida (senão o botão fica invisível e ninguém o
                  encontra), mas só HABILITA com a origem já SALVA: o backend decide pela config
                  gravada, então o disparo antes de salvar seria um no-op com toast de sucesso. */}
              {integracaoAtiva && origemClienteVendedor === 'WS_W3ERP' && (
                <Botao
                  type="button"
                  variante="secundario"
                  disabled={executandoIntegracao || origemSalva !== 'WS_W3ERP'}
                  title={
                    origemSalva === 'WS_W3ERP'
                      ? undefined
                      : 'Salve a configuração para habilitar'
                  }
                  onClick={executarClienteVendedor}
                >
                  Sincronizar cliente x vendedor
                </Botao>
              )}
            </Botoes>
            {integracaoAtiva &&
              origemClienteVendedor === 'WS_W3ERP' &&
              origemSalva !== 'WS_W3ERP' && (
                <Dica style={{ display: 'block', marginTop: '12px' }}>
                  Salve a configuração para habilitar a sincronização manual de
                  cliente x vendedor.
                </Dica>
              )}
          </Secao>

          <Secao>
            <TituloSecao>WhatsApp</TituloSecao>
            <DescricaoSecao>
              Instância usada para o envio de mensagens desta organização.
            </DescricaoSecao>
            <LinhaCampos>
              <Campo>
                <Rotulo htmlFor="idInstancia">Id Instância</Rotulo>
                <Entrada
                  id="idInstancia"
                  type="text"
                  value={idInstancia}
                  onChange={event => setIdInstancia(event.target.value)}
                />
                {erroIdInstancia && <span>*Campo obrigatório</span>}
              </Campo>
              <Campo>
                <Rotulo htmlFor="tokenInstancia">Token Instância</Rotulo>
                <Entrada
                  id="tokenInstancia"
                  largura="220px"
                  type="text"
                  value={tokenInstancia}
                  onChange={event => setTokenInstancia(event.target.value)}
                />
                {erroTokenInstancia && <span>*Campo obrigatório</span>}
              </Campo>
            </LinhaCampos>
            <LinhaSwitch>
              <ToggleSwitch
                adm
                id="whatsAppAtivo"
                label={whatsAppAtivo ? 'Ativo' : 'Inativo'}
                checked={whatsAppAtivo}
                onChange={() => setWhatsAppAtivo(!whatsAppAtivo)}
              />
            </LinhaSwitch>
            <Botoes>
              <Botao
                type="button"
                variante="secundario"
                disabled={criandoInstancia}
                onClick={criarInstancia}
              >
                {criandoInstancia ? 'Criando...' : 'Criar instância'}
              </Botao>
              <Botao
                type="button"
                disabled={salvandoWhatsApp}
                onClick={salvarWhatsApp}
              >
                Salvar
              </Botao>
            </Botoes>
          </Secao>

          <Secao>
            <TituloSecao>Jobs</TituloSecao>
            <DescricaoSecao>
              Disparo manual das rotinas desta organização, apenas para este
              tenant. As rotinas de predição e do Mix rodam em segundo plano; o
              recálculo da Central de Resultados é feito na hora e pode levar
              alguns segundos.
            </DescricaoSecao>
            <Botoes>
              <Botao
                type="button"
                variante="secundario"
                disabled={jobRodando}
                onClick={executarSnapshot}
              >
                Gerar snapshot
              </Botao>
              <Botao
                type="button"
                variante="secundario"
                disabled={jobRodando}
                onClick={executarReconciliacao}
              >
                Reconciliar predições
              </Botao>
              <Botao
                type="button"
                variante="secundario"
                disabled={jobRodando}
                onClick={executarMixRecomendacao}
              >
                Recalcular Mix
              </Botao>
              {/* Congela a competência corrente, fecha a anterior quando é hora e regrava o rollup
                  do Master desta conta. NÃO reabre competência fechada — isso é a ação separada da
                  tela da Central, com confirmação e marca permanente. */}
              <Botao
                type="button"
                variante="secundario"
                disabled={jobRodando}
                onClick={executarCentralResultados}
              >
                Recalcular Central de Resultados
              </Botao>
              <Botao
                type="button"
                variante="secundario"
                disabled={jobRodando}
                onClick={() => setConfirmaExpurgo(true)}
              >
                Expurgar snapshots antigos
              </Botao>
            </Botoes>
          </Secao>
        </>
      )}

      {confirmaRemocaoLogo && (
        <Desativar
          texto="A logo desta organização será removida e o PDF de predição volta a sair com a marca Cartivia. Deseja continuar?"
          botaoNao={() => setConfirmaRemocaoLogo(false)}
          botaoSim={() => {
            setConfirmaRemocaoLogo(false)
            removerLogo()
          }}
        />
      )}

      {confirmaExpurgo && (
        <Desativar
          texto="O expurgo remove definitivamente os snapshots de predição com mais de 12 meses desta organização. Deseja continuar?"
          botaoNao={() => setConfirmaExpurgo(false)}
          botaoSim={() => {
            setConfirmaExpurgo(false)
            executarExpurgo()
          }}
        />
      )}
    </>
  )
}
